import { Injectable } from '@angular/core';
import { BaseclientService } from '../baseclient.service';
import { Observable, from, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToolsService } from '../../tools/tools.service';

@Injectable({
  providedIn: 'root'
})

export class ClientCreditsService {


  constructor(
    private baseClient: BaseclientService,
     private tools: ToolsService
  ) { }





  getCreditsLetter(dateFrom?: string | any, dateTo?: string | any, merchantId?: number | any, display_element?: any): Observable<any> {

    const params = {

      date_from: dateFrom,
      date_to: dateTo,
      merchant_id: merchantId,
      offset: display_element ? display_element.offset : null,
      limit: display_element ? display_element.limit : null
    }

    return from(this.baseClient.postBase("getClientCredits", params)).pipe(
      map((data) => data.client_credits)
    )
  }

  getCreditstoPay(merchantId?: number): Observable<any> {

    const params = {
      merchant_id: merchantId
    }

    return from(this.baseClient.postBase("getClientCreditsToPay", params)).pipe(
      map(data => data.client_credits_to_pay)
    )
  }


  creditCard(value: any, card: any, paypal_order_id?: string, payment_intent_id?: string, paymentIntentId?: any): Promise<any> {
 

    const params: any = {

      payment_type: value.payment_type,
      amount: value.amount,
      merchant_id: value.merchant_id,
      value: value.value,
      pos_id: value.pos_id,
      list_id: value.list,
      paymentIntentId: paymentIntentId ? paymentIntentId : null,
      url:window.location.href

    };


    /**
     * Stripe
     */
    if (params.payment_type === "online") {
      payment_intent_id ? params["payment_intent_id"] = payment_intent_id : params["payment_method_id"] = card.id;
    }

    /**
     * Paypal
     */
    if (params.payment_type === "online_paypal") {
      params["paypal_order_id"] = paypal_order_id ? paypal_order_id : null;

    }

    params['metadata'] = "2"//provenance credit

    if (params.payment_type === "yavin") {
      const myurl = new URL(window.location.href);
      params['url_success'] = myurl;
      params['url_cancelled'] = myurl;
    }

    params["payment_intent_id_saved"] = this.tools.getStor("ClientKeyPayIntenCard")?this.tools.getStor("ClientKeyPayIntenCard").id:null
    params["payment_intent_id_saved_stripe_widget"] = this.tools.getStor("ClientKeyPayIntentCredit")? this.tools.getStor("ClientKeyPayIntentCredit").paymentIntent.id:null;


    return this.baseClient.postBase("clientcreditCardSCA_", params);

  }


  setPaymentPayzen(jsonPayzen: any, id_lettering: any): Promise<any> {
    const params = {
      jsonPayzen: jsonPayzen,
      id_lettering: id_lettering
    };

    return this.baseClient.postBase("paymentCreditSucceeded", params);


  }

  setPaymentCreditMypos(jsonMyPos: any, id_lettering: any): Promise<any> {
    const params = {
      jsonMyPos: jsonMyPos,
      id_lettering: id_lettering
    };

    return this.baseClient.postBase("paymentCreditSucceededMypos", params);


  }



  stripeCreditPaymentSucceeded(lettering_intent_id: any, payment_intent: any): Promise<any> {
   
    const params = {
      lettering_intent_id: lettering_intent_id,
      payment_intent: payment_intent

    };

    return this.baseClient.postBase("paymentCreditStripeSucceeded", params);
  }


 





  yavinCreditPaymentSucceeded(lettering_intent_id: any,status:any,pos_id:any): Promise<any> {
    const params = {
      lettering_intent_id: lettering_intent_id,
      status:status,
      pos_id: pos_id
    };
    return this.baseClient.postBase("yavinPaymentCreditSucceeded", params);
  }











}
